var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 6,
  height: 11,
  viewBox: "0 0 6 11",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.34305 0.5C5.53488 0.5 5.69217 0.561959 5.81531 0.685878C5.93844 0.782595 6 0.940893 6 1.16115L6 9.83885C6 9.99035 5.93844 10.1486 5.81531 10.3141C5.69217 10.438 5.53488 10.5 5.34305 10.5C5.19252 10.5 5.05549 10.438 4.93236 10.3141L0.621263 5.97508C0.456837 5.80999 0.375 5.65169 0.375 5.49981C0.375 5.34869 0.456837 5.19001 0.621263 5.02492L4.93236 0.685878C5.05549 0.561959 5.19252 0.5 5.34305 0.5Z",
  fill: "#4585FF"
})));
export default SvgIconArrow;